<div class="pt-5">
  <app-customer-form
    *ngIf="customerId"
    [customerId]="customerId"
    [contractId]="contractId"
  ></app-customer-form>

  <app-config
    *ngIf="configId"
    [configId]="configId"
    [contractId]="contractId"
  ></app-config>

  <app-instance
    *ngIf="contractId"
    [instanceId]="instanceId"
    [contractId]="contractId"
  ></app-instance>
</div>
